import { __awaiter } from "tslib";
import { scrollSmoothlyToBottom, scrollToBottom } from "../utils.js";
function run() {
    $(() => {
        // TODO: Remove deprecated code
        // $('#refreshLog').on('click', async () => {
        // 	const { html } = await Loading.await(api.get(location.pathname + '?json=true'))
        // 	$('#log').replaceWith(html)
        // 	await sleep(10)
        // 	scrollSmoothlyToBottom('#log')
        // })
        $('#refreshLog').on('click', () => __awaiter(this, void 0, void 0, function* () {
            refreshLog();
        }));
        scrollToBottom('#log');
    });
}
let lastId = 0;
function refreshLog() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const from = lastId || $('#log span:last-of-type').attr('logid');
        const res = yield Loading.await(api.get(`${location.pathname}/${from}?json=true`));
        const { ids, html } = res;
        lastId = (_a = ids.pop()) !== null && _a !== void 0 ? _a : lastId;
        console.log('refreshLog', { from, html });
        const $last = $('#log *:last-child');
        const now = moment().format('YYYY-MM-DD HH:mm:ss');
        $last.after(/*html*/ `<span logid="${from}" class="timestamp no-select">${now}</span>: <b style="font-weight: 400; color: #000; opacity: 0.6;">&ltrefresh&gt</b><br/>`);
        if (html) {
            $last.after(html);
        }
        if ($('#autoScroll').is(':checked')) {
            scrollSmoothlyToBottom('#log');
        }
    });
}
Object.assign(globalThis, { refreshLog });
export const page_log = {
    requiresAuth: true,
    run: run,
};
//# sourceMappingURL=log.js.map